export const environment = {
  production: true,
  apiBaseUrl: 'https://idea-software-prod-app-service.azurewebsites.net/api',
  aadClientId: '37bdb299-9d80-490e-816e-e8240c9d25e9',
  aadTenantId: '92f46c1a-644a-40e4-83a0-c7b24680b25c',
  version: '0.1.0',
  environment: 'prod',
  agGridLicenseKey: '',
};
